import { render, staticRenderFns } from "./InfoBlock.vue?vue&type=template&id=2140cd1f&scoped=true"
import script from "./InfoBlock.vue?vue&type=script&lang=js"
export * from "./InfoBlock.vue?vue&type=script&lang=js"
import style0 from "./InfoBlock.vue?vue&type=style&index=0&id=2140cd1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2140cd1f",
  null
  
)

export default component.exports